<div class="webgl-unsupported-container" data-testid="webgl-unsupported">
  <kh-img class="warning-icon" path="https://staticcontent.knowledgehook.com/content/khg/ui/common/warning.png" alt="warning"></kh-img>
  <p class="warning-message white">{{ 'WEBGL_UNSUPPORTED.MESSAGE' | translate }}</p>
</div>
